import { operatorCompaniesFeature } from '../reducers/operator-companies.reducer';

export const {
  selectOperatorCompaniesState,
  selectCompanies: selectOperatorCompanies,
  selectIsLoading: selectOperatorCompaniesIsLoading,
  selectError: selectOperatorCompaniesError,
} = operatorCompaniesFeature;
